module.exports = __webpack_public_path__ + "static/img/highTest.673843e4.jpg";